import { getPropsForClickTracking } from "../../utils/tracking";
$ const { visible, mapParamsGathering, userLocationZipcode } = input;
$ const { zipcodeValue, distanceValue, showErrorMessage } = state;
$ const disableSubmit = !zipcodeValue || !distanceValue;
$ const locationParams = mapParamsGathering?.locationParams || {};
$ const {
  postalCodeEntry = {},
  actions = [],
  closeOverlay,
  title,
  distanceSlider,
} = locationParams;
$ const { title: postalCodeEntryTitle } = postalCodeEntry;
$ const closeAction = actions?.find(({ action }: any) => action?.name === "CANCEL_UPDATE_LOCAL_LOCATION");
$ const updateAction = actions?.find(({ action }: any) => action?.name === "APPLY_UPDATE_LOCAL_LOCATION");
$ const useSlider = !!distanceSlider;

<if(visible)>
  <div class="postcode-inquiry-page">
    <div class="postcode-inquiry-page__content">
      <div class="postcode-inquiry-page__form-card">
        <div class="postcode-inquiry-page__form-header">
          <h2 class="postcode-inquiry-page__form-title" data-testid="postcode-inquiry-title">
            <fe-textual-display model=postalCodeEntryTitle/>
          </h2>
          <ebay-icon-button
            data-testid="postcode-inquiry-close"
            on-click("emit", "close")
            aria-label=closeOverlay?.accessibilityText || "Close"
            ...getPropsForClickTracking(closeOverlay?.trackingList)
          >
            <ebay-close-16-icon/>
          </ebay-icon-button>
        </div>

        <div class="postcode-inquiry-page__form">
          <map-location-form
            locationParams=locationParams
            userLocationZipcode=userLocationZipcode
            zipcodeValue=zipcodeValue
            distanceValue=distanceValue
            showErrorMessage=showErrorMessage
            distanceVariant=(useSlider ? "slider" : "radio")
            on-postcode-change("onPostCodeTextboxChange")
            on-use-user-zipcode("useUserZipcode")
            on-distance-change("onDistanceOptionChange")
          />
        </div>

        <div class="postcode-inquiry-page__form-actions">
          <ebay-button
            data-testid="postcode-inquiry-footer-btn-close"
            priority="tertiary"
            on-click("emit", "close")
            ...getPropsForClickTracking(closeAction?.action?.trackingList)
          >
            <fe-textual-display model=closeAction?.text/>
          </ebay-button>

          <ebay-button
            data-testid="postcode-inquiry-footer-btn-submit"
            priority="primary"
            on-click("onSubmit")
            disabled=disableSubmit
            ...getPropsForClickTracking(updateAction?.action?.trackingList)
          >
            <fe-textual-display model=updateAction?.text/>
          </ebay-button>
        </div>
      </div>

      <div class="postcode-inquiry-page__message">
        <h1 class="postcode-inquiry-page__message-text">
          <fe-textual-display model=title/>
        </h1>
      </div>
    </div>
  </div>
</if>
